import * as React from 'react';

function SvgFlowBranch(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 18 24" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M18 3.43a3.38 3.38 0 10-6.75 0 3.41 3.41 0 001.95 3.09c-.12 2.27-1.79 3-4.69 4.14a18.62 18.62 0 00-3.73 1.76V6.54a3.44 3.44 0 002-3.11A3.4 3.4 0 003.37 0 3.4 3.4 0 000 3.43a3.44 3.44 0 002 3.11v10.92a3.44 3.44 0 00-2 3.11A3.4 3.4 0 003.37 24a3.43 3.43 0 001.43-6.52c.12-2.27 1.79-3 4.69-4.14s6.39-2.45 6.53-6.8A3.43 3.43 0 0018 3.43zm-14.63-2a2 2 0 012 2 2 2 0 01-1.95 2 2 2 0 01-1.94-2 2 2 0 011.89-1.98zm0 21.1a2 2 0 010-4 2 2 0 010 4zM14.63 5.41a2 2 0 01-2-2 1.95 1.95 0 113.89 0 2 2 0 01-1.89 2z" />
    </svg>
  );
}

const MemoSvgFlowBranch = React.memo(SvgFlowBranch);
export default MemoSvgFlowBranch;
